import React, { useRef, useEffect, useState } from "react";
import Loading from "../components/loading";
import { maskEmail } from "../function/functions";
import secureLocalStorage from "react-secure-storage";
import { getAxiosWithOutToken } from "../axios/axiosObj";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../assets/images/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { verifyOtp } from "../store/features/webUtilitiesSlice";

const GymCategories = () => {
  const navigate = useNavigate();
  const { errorMsg } = useSelector((state) => state.webUtilities);
  const dispatch = useDispatch();
  const [isLoading] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [errorMsg2, setErrorMsg] = useState("");
  const [continueBtn, setContinueBtn] = useState(false);
  const numberOfDigits = 6;
  const [otp, setOtp] = useState(new Array(numberOfDigits).fill(""));
  const otpBoxReference = useRef([]);

  useEffect(() => {
    if (secureLocalStorage.getItem("userEmail")) {
      setUserEmail(secureLocalStorage.getItem("userEmail"));
    } else {
      navigate("/login");
    }
    if (secureLocalStorage.getItem("isResended")) {
      setIsResendOtp(secureLocalStorage.getItem("isResended") ? false : true);
    }
  }, []);

  const initialTotalSeconds = secureLocalStorage.getItem("remainingTime")
    ? Number(secureLocalStorage.getItem("remainingTime"))
    : 3 * 30; // Initial timer value in seconds (2 minutes)

  const [totalSeconds, setTotalSeconds] = useState(initialTotalSeconds);

  // Format the totalSeconds into HH:MM:SS
  const formatTime = (seconds) => {
    const minutes = Math.floor((seconds % 3600) / 60);
    const secondsRemain = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      secondsRemain
    ).padStart(2, "0")}`;
  };

  // State to hold the formatted time string
  const [timer, setTimer] = useState(formatTime(initialTotalSeconds));
  const [isResendOtp, setIsResendOtp] = useState(false);

  useEffect(() => {
    if (!isResendOtp && secureLocalStorage.getItem("remainingTime")) {
      const interval = setInterval(() => {
        setTotalSeconds((prevSeconds) => {
          if (prevSeconds === 0) {
            clearInterval(interval);
            setIsResendOtp(true);
            secureLocalStorage.removeItem("remainingTime");
            secureLocalStorage.removeItem("isResended");
            return 0;
          }
          const newSeconds = prevSeconds - 1;
          secureLocalStorage.setItem("remainingTime", String(newSeconds));
          secureLocalStorage.setItem("isResended", "ture");
          return newSeconds;
        });
      }, 1000);

      return () => clearInterval(interval);
    } else {
      setIsResendOtp(true);
    }
  }, [isResendOtp]); // Run this effect only once when the component mounts

  useEffect(() => {
    // Update the formatted time string whenever totalSeconds changes
    setTimer(formatTime(totalSeconds));
  }, [totalSeconds]);

  const handleResendOtp = async () => {
    setOtp(new Array(numberOfDigits).fill(""));
    setIsResendOtp(false);
    if (secureLocalStorage.getItem("isResended")) {
      secureLocalStorage.removeItem("isResended");
    }
    secureLocalStorage.setItem("remainingTime", String(initialTotalSeconds)); // Reset totalSeconds
    setTotalSeconds(initialTotalSeconds); // Reset timer
    try {
      const emailResponse = await getAxiosWithOutToken({
        method: "POST",
        url: "/pre/auth/send-otp",
        data: { email: userEmail },
      });
      if (emailResponse && emailResponse.status === 200) {
        setErrorMsg(`OTP resend to ${userEmail}`);
        setTimeout(() => {
          setErrorMsg("");
        }, 2500);
      } else {
        setErrorMsg(emailResponse.data.message);
      }
    } catch (error) {
      setErrorMsg(error.response.data.error.message || "Something went wrong");
    }
  };

  if (isLoading) return <Loading />;
  const handleLogin = async () => {
    if (!continueBtn) {
      setErrorMsg("Enter the OTP");
      return false;
    }
    let otpvalue = otp.join("");
    try {
      const data = { email: userEmail, otp: otpvalue };
      await dispatch(verifyOtp(data));
    } catch (error) {
      setErrorMsg(
        error.response.data.error.message || "❌ Wrong OTP Please Check Again"
      );
    }
  };

  function handleChange(value, index) {
    let newArr = [...otp];
    newArr[index] = value;
    setOtp(newArr);

    if (value && index < numberOfDigits - 1) {
      otpBoxReference.current[index + 1].focus();
    }
    if (index === 5 && value === "") {
      setContinueBtn(false);
    } else if (index === 5 && value !== "") {
      setContinueBtn(true);
    }
  }

  function handleBackspaceAndEnter(e, index) {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      otpBoxReference.current[index - 1].focus();
    }
    if (e.key === "Enter" && e.target.value && index < numberOfDigits - 1) {
      otpBoxReference.current[index + 1].focus();
    }
  }

  return (
    <div className="manlay bg-white">
      <div className="bodyly mt-16">
        <div
          className={`logo w-full flex justify-center top-0 z-30 fixed py-2 pt-3 left-0 bg-white`}
        >
          <img
            loading="lazy"
            src={Logo}
            alt="logo"
            className="h-auto w-32 z-30"
            width={100}
            height={30}
          />
        </div>
        <div className="w-full sm:mt-28 mt-20 mb-10">
          <div className="tex mt-24 mb-10">
            <p>A 6 digit code has been sent to {maskEmail(userEmail)}</p>
          </div>
          <div className="verfiydes mb-10">
            {otp?.map((digit, index) => (
              <input
                type="text"
                key={index}
                value={digit}
                name="verfil"
                className="verfirbox"
                maxLength={1}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyUp={(e) => handleBackspaceAndEnter(e, index)}
                ref={(reference) =>
                  (otpBoxReference.current[index] = reference)
                }
                autoComplete="off"
              />
            ))}
          </div>
          <div className="tex mb-6">
            <span className="tex  text-sm">Didn’t receive code?</span>
            {isResendOtp ? (
              <span
                className="loginbotm cursor-pointer text-sm"
                onClick={handleResendOtp}
              >
                Resend code
              </span>
            ) : (
              <span className="loginbotm cursor-not-allowed text-gray-500 text-sm">
                Resend code({timer})
              </span>
            )}
          </div>

          <p className="text-sm text-red-500 text-center">
            {errorMsg || errorMsg2}
          </p>
          <div className="btmain w-11/12 mt-3 text-sm mx-auto text-center">
            <div
              onClick={handleLogin}
              className={`sm:w-full w-10/12 mx-auto font-medium text-xl bottontex bottonly sm:py-4 py-3  ${
                continueBtn ? "bottonlyac" : "bg-gray-300"
              }`}
            >
              Verify
            </div>
            <div className="tex mt-6">
              <span className="tex">Don’t have an account?</span>
              <a href="https://fastbetter.com" className="loginbotm">
                Begin your journey
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default GymCategories;
